<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 15:37:12
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 14:19:24
 * @name: 主界面
 * @Description: 主界面
 * @FilePath: \preSaleNafterSaleBackstage\src\views\Index.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="index">
      <Head class="head"></Head>
      <div class="content">
          <keep-alive :include="cashRouters">
              <router-view></router-view>
          </keep-alive>
      </div>
  </div>
</template>
<script>
import Head from '@/components/index/Head';
export default {
  name: "index",
  components: {
      Head
  },
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    }
  },
};
</script>
<style lang="scss" scoped>
.index{
    width: 100%;
    min-width: 1280px;
    height: 100%;
    box-sizing: border-box;
    @extend .extend-flex-column-normal;
    .head{
        flex-shrink: 0;
    }
    .content{
        width: 100%;
        height: calc(100% - #{$Vars-head-height});
        background: $Vars-background-light-gray;
        overflow-y: auto;
    }
}
</style>